var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "delete_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17 5.98h3c.55 0 1 .45 1 1s-.45 1-1 1h-1v11c0 1.65-1.35 3-3 3H8c-1.65 0-3-1.35-3-3v-11H4c-.55 0-1-.45-1-1s.45-1 1-1h3v-1c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3zm-7-2c-.55 0-1 .45-1 1v1h6v-1c0-.55-.45-1-1-1zm6 16c.55 0 1-.45 1-1v-11H7v11c0 .55.45 1 1 1zm-6-2c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1m4 0c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1",
  clipRule: "evenodd"
})));
export default SvgDelete;